import React from 'react'
import { TankForm } from '../components/tankForm'

export const TanksEditPage: React.FC<any> = props => {
  const tankInfo = props.location.state?.tank
  // const isPast = props.location.state?.isPast
  const readOnly = props.location.state?.readOnly

  //#endregion

  return <TankForm tank={tankInfo} readOnly={readOnly} />
}
